import React from 'react'
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined'

const SceneAccessGateShell = ({
    icon = null,
    kicker = 'Гостевой 3D-доступ',
    title,
    description,
    children,
    error = '',
    note = '',
    className = '',
}) => {
    return (
        <main className={['sceneGuestUnlock', 'sceneAccessGateway', className].filter(Boolean).join(' ')}>
            <section className="sceneGuestUnlock__card sceneAccessGateway__card">
                <div className="sceneGuestUnlock__icon sceneAccessGateway__icon">
                    {icon || <KeyOutlinedIcon />}
                </div>

                <div className="sceneAccessGateway__copy">
                    <span>{kicker}</span>
                    <h1>{title}</h1>
                    {description ? <p>{description}</p> : null}
                </div>

                {children}

                {error ? (
                    <div className="sceneGuestUnlock__error sceneAccessGateway__error">
                        {error}
                    </div>
                ) : null}

                {note ? (
                    <div className="sceneAccessGateway__note">
                        {note}
                    </div>
                ) : null}
            </section>
        </main>
    )
}

export default SceneAccessGateShell
